import ServiceDirectoryPage from "./ServiceDirectoryPage"

const NationalHelplineWrapper = () => {
  return (
    <ServiceDirectoryPage isNationalHelplines />
  );
}

export default NationalHelplineWrapper;